import type { ChartEcharts } from './chart-render';

let loading: Promise<ChartEcharts> | null = null;

/**
 * Carrega o ECharts (só o que o gráfico usa: ver chart-echarts.modules.ts) na primeira vez
 * que alguém precisa dele: o editor sem gráfico não paga o download.
 *
 * O build modular desenha igual ao completo que a API usa (mesma versão, mesmas peças):
 * o SVG da web e o gravado pela API saem idênticos.
 */
export function loadChartEcharts(): Promise<ChartEcharts> {
    loading ??= import('./chart-echarts.modules')
        .then(module => module.chartEcharts)
        .catch(error => {
            // Falhou (rede caiu no meio): a próxima tentativa baixa de novo.
            loading = null;
            throw error;
        });

    return loading;
}
